module.exports = __webpack_public_path__ + "static/media/joshhill15_small.74aca52b.png";